import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//用于响应组件中动作
const actions = {
	updateUseInfo(context, userInfo) {
		context.commit('updateUseInfo', userInfo)
	},
	removeUserInfo(context) {
		context.commit('updateUseInfo')
	},
	updateUserCo(context, coId) {
		context.commit('updateUserCo', coId)
	},
	updateUserCoName(context, coName) {
		context.commit('updateUserCoName', coName)
	},
	updateDept:(context, dept) => context.commit('updateDept', dept)
}

//用户操作数据
const mutations = {
	updateUseInfo(state, userInfo) {
		state.userInfo = userInfo
	},
	removeUserInfo(state) {
		console.log(' mutations 退出登录')
		state.userInfo = {}
	},
	updateUserCo(state, coId) {
		state.userCo = coId
	},
	updateUserCoName(state, coName) {
		state.userCoName = coName
	},
	updateDept:(state, dept) => state.dept = dept
}

//存储数据
const state = {
	systemName: '睿畅油链管理平台',
	userInfo: {},
	isLogin: false,
	userCo: undefined, //用户登录企业主键
	userCoName: undefined, //用户登录企业名称
	dept:{}
}

const localStoragePlugin = store => {
	// 初始化时从 localStorage 恢复状态
	if (localStorage.getItem('ylcache')) {
		store.replaceState(
			Object.assign({}, store.state, JSON.parse(localStorage.getItem('ylcache')))
		)
	}

	// 订阅 store 变化
	store.subscribe((mutation, state) => {
		// 每次 mutation 后保存整个状态
		localStorage.setItem('ylcache', JSON.stringify(state))
	})
}

export default new Vuex.Store({
	actions,
	mutations,
	state,
	plugins: [localStoragePlugin]
})